import { TableHead, SearchData } from "../../../../common/dataClass/Default"
import { BudgetProfitTest } from '../../../../common/dataClass/Profit'
import globalData from '../../../../common/globalData'

let profitBudgetKey = {
  id: 'budgetId',
  lengthType: 'unitIndex',
  weightType: 'unitIndex',
  storeId: 'store',
  pictureUrl: 'img',
  storeName: 'storeName',
  remarks: 'remark',
  updateTime: 'time',
  saveRate: 'saveRate',
  productName: 'name',
  productLength: 'long',
  productWidth: 'width',
  productHeight: 'height',
  productWeight: 'weight',
  commission: 'commission',
  productType: 'sort',
  productUnit: 'unit',
  purchaseNum: 'stockNum',
  purchasePrice: 'stockPrice',
  domesticFreight: 'domesticFreight',
  foreignFreight: 'internationFreight',
  monthlyAdvertisingFee: 'advertisingFee',
  fakeOrderFee: 'billingFee',
  attractPeopleFee: 'drainageFee',
  saleCommissionRate: 'salesCommission',
  buyAndOperationCommissionRate: 'operationCommission',
  otherFee: 'otherFee',
  productPrice: 'sellingPrice',
  damageProduct: 'disposalNum',
  returnProduct: 'returnNum',
  inWarehouseNum: 'positionDay',
  productSales: 'showSales',
  countrySite: 'countrySite',
  sellerType: 'sellerType',
  mergeConfiguration: 'warehouseConfiguration',
  returnLossRate: 'recoveryLossRate',
  customsPrice: 'saleTax',
  monthlyFinanceAndTaxation: 'taxExpense',
  importDuty: 'importTariff',
  operationInterestRateYearly: 'operatingAnnualInterestRate',
  calType: 'calType',
  dealMonthly: 'dealFee',
  couponMonthly: 'couponFee',
  monthlyRemoveOrderNum: 'dyqzycsl',
}

let backendComputationCostDataKey = {
  total: 'totalCost',
}
let backendComputationProfitDataKey = {
  productGrossProfit: 'netProfit',
  productContributionCost: 'costOfCapital',
  productActualCollection: 'collectionOfPayment',
  productGrossProfitRate: 'salesProfitMargin',
  productCostProfitRate: 'costProfitMargin',
  productTotalGrossProfit: 'totalSalesProfit',
}

/**选品利润预算 */
class BudgetProfit extends BudgetProfitTest{
  constructor(rate = [], obj = {}){
    super(rate, obj)
    this.budgetId = ''
    /**店铺 */
    this.store = null
    this.storeName = ''
    /**图片 */
    this.img = ''
    /**商品名称 */
    this.name = ''
    /**更新时间 */
    this.time = ''
    /**保存时汇率 */
    this.saveRate = 0
    /**备注 */
    this.remark = ''
    /**后端计算数据 */
    this.backendComputationData = {
      /**产品售价 */
      price: '',
      /**总成本费用 */
      totalCost: '',
      /**商品净利润 */
      netProfit: '',
      /**总出资成本 */
      costOfCapital: '',
      /**商品收汇 */
      collectionOfPayment: '',
      /**销售利润率 */
      salesProfitMargin: '',
      /**成本利润率 */
      costProfitMargin: '',
      /**总销售利润 */
      totalSalesProfit: '',
    }
  }
  /**清空数据 */
  clearData(){
    super.clearData()
    this.img = ''
    this.name = ''
    this.remark = ''
    this.store = null
  }
  /**需要输入的数据 */
  needArray(){
    let arr = super.needArray()
    arr = arr.concat(['img', 'name', 'store'])
    return arr
  }
  /**新建预算请求体 */
  get getNewProductBudgetAxiosBody(){
    let obj = {
      storeId: this.store,
      picture: this.img,
      remarks: this.remark,
      productName: this.name,
      productLength: this.long,
      productWidth: this.width,
      productHeight: this.height,
      productWeight: this.weight,
      commission: this.commission,
      productType: this.sort,
      productUnit: this.unit,
      purchaseNum: this.stockNum,
      purchasePrice: this.stockPrice,
      domesticFreight: this.domesticFreight,
      foreignFreight: this.internationFreight,
      monthlyAdvertisingFee: this.advertisingFee,
      fakeOrderFee: this.billingFee,
      attractPeopleFee: this.drainageFee,
      saleCommissionRate: this.salesCommission,
      buyAndOperationCommissionRate: this.operationCommission,
      otherFee: this.otherFee,
      productPrice: this.sellingPrice,
      damageProduct: this.disposalNum,
      returnProduct: this.returnNum,
      inWarehouseNum: this.positionDay,
      productSales: this.showSales,
      countrySite: this.countrySite,
      sellerType: this.sellerType,
      mergeConfiguration: this.warehouseConfiguration,
      lengthType: this.unitIndex,
      weightType: this.unitIndex,
      returnLossRate: this.recoveryLossRate,
      customsPrice: this.saleTax,
      monthlyFinanceAndTaxation: this.taxExpense,
      importDuty: this.importTariff,
      operationInterestRateYearly: this.operatingAnnualInterestRate,
      calType: this.calType,
      dealMonthly: this.dealFee? this.dealFee: 0,
      couponMonthly: this.couponFee? this.couponFee: 0,
      monthlyRemoveOrderNum: this.dyqzycsl? this.dyqzycsl: 0,
      monthlyIndemnityCollection: this.dybpcsl? this.dybpcsl: 0
    }
    return obj
  }
  /**修改预算请求体 */
  get getUpdateProductBudgetAxiosBody(){
    let obj = this.getNewProductBudgetAxiosBody
    obj.id = this.budgetId
    return obj
  }
  /**导入后端返回的列表数据 */
  backendListDataParsing(obj){
    let pKeys = Object.keys(profitBudgetKey)
    let bCCDKeys = Object.keys(backendComputationCostDataKey)
    let bCPDKeys = Object.keys(backendComputationProfitDataKey)
    pKeys.map(key => {
      this[profitBudgetKey[key]] = String(obj[key])
    })
    bCCDKeys.map(key => {
      this.backendComputationData[backendComputationCostDataKey[key]] = obj.productCalculate.productCost[key]
    })
    bCPDKeys.map(key => {
      this.backendComputationData[backendComputationProfitDataKey[key]] = obj.productCalculate.productProfit[key]
    })
  }
  /**保存时产品售价 */
  get getSavePriceByTable(){
    let num = this.sellingPrice * this.saveRate
    return '¥' + globalData.keepDecimalPoint(num, 2)
  }
  /**总成本与费用 */
  get getCostSummaryByTable(){
    let num = Number(this.backendComputationData.totalCost)
    return '¥' + globalData.keepDecimalPoint(num, 2)
  }
  /**商品净利润 */
  get getNetProfitOfGoodsByTable(){
    let num = Number(this.backendComputationData.netProfit)
    return '¥' + globalData.keepDecimalPoint(num, 2)
  }
  /**总出资成本 */
  get getCostOfCommodityInvestmentByTable(){
    let num = Number(this.backendComputationData.costOfCapital)
    return '¥' + globalData.keepDecimalPoint(num, 2)
  }
  /**商品收汇 */
  get getCommodityCollectionByTable(){
    let num = Number(this.backendComputationData.collectionOfPayment)
    return '¥' + globalData.keepDecimalPoint(num, 2)
  }
  /**当月显示销量和当月实际销量 */
  get getShowNumAndActualNumByTable(){
    return super.getDisplaySalesVolumeForCalculationPurposes + '<br>(' + super.getCalculateBasedOnActualSalesVolume + ')'
  }
  /**当月销售利润率 */
  get getMonthlySalesProfitMarginByTable(){
    let num = Number(this.backendComputationData.salesProfitMargin)
    return globalData.keepDecimalPoint(num, 1) + '%'
  }
  /**当月成本利润率 */
  get getMonthlyCostProfitMarginByTable(){
    let num = Number(this.backendComputationData.costProfitMargin)
    return globalData.keepDecimalPoint(num, 1) + '%'
  }
  /**当月总销售利润 */
  get getTotalSalesProfitForTheMonthByTable(){
    let num = Number(this.backendComputationData.totalSalesProfit)
    return globalData.keepDecimalPoint(num, 0)
  }
  /**更新时间和更新状态 */
  get getTimeAndStatus(){
    return new Date(this.time).Format('yyyy-MM-dd hh:mm:ss') + '<br>' + '(更新完成)'
  }
}

/**搜索数据 */
class ProfitSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**选品利润预算表头 */
class ProfitTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class ProfitFromProductSelectNewModule{
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '点击 "新建选品利润预算"',
      '输入预选商品数据',
      '保存预算数据',
      '点击"查看"',
      '点击"修改"更新数据',
      '保存更新的预算数据'
    ]
    return arr
  }
  /**选品利润预算表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new ProfitTableHead('商品图片', 'img', '100'),
      new ProfitTableHead('商品名称', 'name', '100'),
      new ProfitTableHead('店铺名称', 'storeName', '100'),
      new ProfitTableHead('国家站点', 'countrySiteName', '100'),
      new ProfitTableHead('计价<br>单位', 'unitName', '50'),
      new ProfitTableHead('采购价格<br>(¥/单位)', 'stockPrice', '80'),
      new ProfitTableHead('商品售价<br>(¥/单位)', 'getSavePriceByTable', '80'),
      new ProfitTableHead('总成本与费用<br>(¥/单位)', 'getCostSummaryByTable', '120'),
      new ProfitTableHead('商品净利润<br>(¥/单位)', 'getNetProfitOfGoodsByTable', '100'),
      new ProfitTableHead('总出资成本<br>(¥/单位)', 'getCostOfCommodityInvestmentByTable', '100'),
      new ProfitTableHead('商品收汇<br>(¥/单位)', 'getCommodityCollectionByTable', '80'),
      new ProfitTableHead('当月显示销量<br>(当月实际销量)', 'getShowNumAndActualNumByTable', '120'),
      new ProfitTableHead('当月坏品<br>退货量', 'disposalNum', '80'),
      new ProfitTableHead('商品当前<br>库存量', 'positionDay', '80'),
      new ProfitTableHead('当月销售<br>利润率(%)', 'getMonthlySalesProfitMarginByTable', '80'),
      new ProfitTableHead('当月成本<br>利润率(%)', 'getMonthlyCostProfitMarginByTable', '80'),
      new ProfitTableHead('当月总销售<br>利润(¥)', 'getTotalSalesProfitForTheMonthByTable', '100'),
      new ProfitTableHead('更新时间<br>(更新状态)', 'getTimeAndStatus', '80'),
      new ProfitTableHead('操作', 'operate', '100'),
    ]
    return arr
  }
  /**选品利润预算更多信息表头 */
  static NEWTABLEMOREHEAD(){
    let arr = [
      new ProfitTableHead('商品图片', 'img', '100'),
      new ProfitTableHead('商品名称', 'name', '100'),
      new ProfitTableHead('店铺名称', 'storeName', '100'),
      new ProfitTableHead('到仓运费<br>(¥/单位)', 'getCostSummary', '110'),
      new ProfitTableHead('到仓成本<br>(¥/单位)', 'getNetProfitOfGoods', '110'),
      new ProfitTableHead('亚马逊总费用<br>(¥/单位)', 'getCostOfCommodityInvestment', '160'),
      new ProfitTableHead('当月实际总收汇<br>(¥/单位)', 'getCommodityCollection', '160'),
      new ProfitTableHead('当月显示销售总额<br>(¥)', 'getShowNumAndActualNum', '110'),
      new ProfitTableHead('当月实际销售总额<br>(¥)', 'disposalNum', '110'),
      new ProfitTableHead('当前库存成本<br>(¥)', 'positionDay', '110'),
      new ProfitTableHead('运营管理提成率<br>(%)', 'getMonthlySalesProfitMargin', '110'),
      new ProfitTableHead('运营管理提成<br>(¥)', 'getMonthlyCostProfitMargin', '110'),
      new ProfitTableHead('销售提成率<br>(%)', 'getTotalSalesProfitForTheMonth', '110'),
      new ProfitTableHead('销售提成<br>(¥)', 'getTimeAndStatus', '110'),
      new ProfitTableHead('商品管理员编号', 'operate', '120'),
    ]
    return arr
  }
  /**选品成本与费用表头 */
  static NEWCOSTTABLEHEAD(){
    let arr = [
      new ProfitTableHead('商品<br>图片', 'img', '80'),
      new ProfitTableHead('国家<br>站点', 'countrySiteName', '80'),
      new ProfitTableHead('采购单价<br>(¥/单位)', 'stockPrice', '100'),
      new ProfitTableHead('国内运费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('国际运费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('进口关税<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('销售佣金<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('当地配送费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站内广告费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站内Deal<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('站内Coupon<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站外测评费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站外引流费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('销售提成<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('管理提成<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('收汇损失<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('资金成本<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('坏品损耗<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('非坏品损耗<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('仓储费用<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('合仓费用<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('账户固定费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('总成本与费用<br>(¥/单位)', 'unit', '120'),
    ]
    return arr
  }
}

export { ProfitSearchData, ProfitFromProductSelectNewModule, BudgetProfit }
